import type { ErrorInfo } from 'react';
import { isExpectedApiFailure } from './isExpectedApiFailure.ts';

/**
 * Wraps a React root error handler so an expected API failure that reached a
 * boundary is not reported as a crash. Everything else still goes to `report`.
 */
export function reportUnlessExpected(
  report: (error: unknown, errorInfo: ErrorInfo) => void,
): (error: unknown, errorInfo: ErrorInfo) => void {
  return (error, errorInfo) => {
    if (!isExpectedApiFailure(error)) {
      report(error, errorInfo);
    }
  };
}
